define('drops/dropDown_v2/dropDown_v2',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq/util',
    'underscore',
    'lq/tooltip',
    'lq/html',
    'lq/required',
    'drops/modals',
    'lq/dynamicContentImage',
    'lq',
    'lq/dropDownsListPositioning',
    './dropkick'
], function ($, Drop, Style, util, _, Tooltip, html, Required, modals, dynamicContentImage, lq, dropDownsListPositioning) {
    'use strict';

    var defaults = {
        data: {
            showEmptyItem: true,
            hideEmptyItemInList: false,
            title: {
                option: Tooltip.hardcoded
            },
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            }
        }
    };

    var offsetToTheEdge = 10;
    var offsetFromInput = 4;
    var defMaxHeight = 159;

    function Dropdown(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing);
        this.loaded = false;
        this.value = null;
        this.valueIsNumber = false;

        this.$element
            .addClass('boxToBorderSize')
            .css({
                whiteSpace: 'pre-wrap'
            });

        var self = this;
        this.$dropDown = $('<select />')
            .attr('id', this.rootDrop.instanceId + '_' + this.data.id)
            .css({
                width: '100%',
                height: '100%'
            })
            .on('change', this.valueChanged.bind(this))
            .attr('tabindex', self.data.tabIndex)
            .appendTo(self.$element);

        if (this.data.readOnly)
            this.$dropDown.prop('disabled', true);

        this.subscribeEventHandler(this.$dropDown, 'change', this.handleChange.bind(this));

        this.tooltip = new Tooltip(this, this.data.title, this.$dropDown);
    };

    Drop.extend(Dropdown, Drop);

    Dropdown.typeName = 'Dropdown_v2';

    Dropdown.prototype.handleChange = function() {
        if (this.$dropDown.val()) {
            var arg = this.$dropDown.val();
            this.triggerEventIfEnabled('selected', arg);
            this.triggerEventIfEnabled('changed', arg);
        } else {
            this.triggerEventIfEnabled('deselected', null);
            this.triggerEventIfEnabled('changed', null);
        }

        this.updateRequiredIndicator();
    };

    Dropdown.prototype.preRender = function () {
        var self = this;
        this.tooltip.update();
        this.piping.visibility.apply(this);
        this.piping.required.apply(this);
        this.piping.datasources.registerDatasourceListener(
            this.data.dataSource,
            function (data) { self._update(data); },
            function (params) {
                if (self.data.pageSize) {
                    params.pageSize = self.data.pageSize;
                }
            });
        Required.prototype.addRemoveRequiredIndicator(self);

        this.applyPosition();
        this.renderMockData();
    };

    Dropdown.prototype.postRender = function() {
        var self = this;
        this.dropKickObject = new Dropkick(this.$dropDown[0],
            {
                initialize: function () {
                    var $oList = $(this.data.optList)
                    if (typeof self.data.styles === 'string') {
                        Style.renderStyles(self, null, $oList);
                    }
                    $oList.addClass('prevent-hover');
                    $oList.addClass('prevent-normal');
                },
                mobile: true,
                change: $.noop,
                open: function () {
                    self.renderDropdown();
                    self.$dropDownButton.addClass('open');
                    self.$dropDownButton.removeClass('close');
                    self.$dropdownButtonWrapper.addClass('open');
                    self.$dropdownButtonWrapper.removeClass('close');
                },
                close: function () {
                    self.$dropDownButton.removeClass('open');
                    self.$dropDownButton.addClass('close');
                    self.$dropdownButtonWrapper.removeClass('open');
                    self.$dropdownButtonWrapper.addClass('close');
                },
                search: "strict",
                bubble: true
            });
        this.$dkSelected = this.$element.find('.dk-selected');
        this.togglePlaceholder(true);

        if (this.data.hideEmptyItemInList && this.data.showEmptyItem)
            $(this.dropKickObject.data.optList).addClass('empty-item-hidden');

        this.subscribeEventHandler(this.piping.$actionWrapper, 'scroll', this.handleScroll.bind(this));

        this.subscribeEventHandler($(window), 'resize', _.debounce(this.renderDropdown.bind(this, true), 50));

        Style.renderStyles(this, null, this.$dkSelected);
        this.ensureRightPadding();

        this.addButton();
    };

    Dropdown.prototype.renderDropdown = function (isResizing) {
        var $oList = $(this.dropKickObject.data.optList);
        if (isResizing && !$oList.is(':visible'))
            return;
        var $dropElement = $(this.$dropDown[0].parentNode);

        var rect = $dropElement[0].getBoundingClientRect();

        var horizontalBorderWidthOfList = $oList.outerWidth() - $oList.innerWidth();
        var width = rect.width - horizontalBorderWidthOfList;

        var css = {
            position: 'absolute',
            zIndex: modals.getZIndexForPopups(),
            width: width,
            left: $dropElement.offset().left
        };
        $oList.css(css);
        dropDownsListPositioning.positionList($oList, $dropElement, offsetFromInput, offsetToTheEdge, this.data.listMaxHeight || defMaxHeight);
    };

    Dropdown.prototype.addButton = function () {
        var self = this;
        this.$dropdownButtonWrapper = $('<div/>')
            .addClass("dropdown-button-wrapper")
            .addClass("close")
            .appendTo(this.$dkSelected);

        this.$dropDownButton = $('<div/>')
            .addClass("dropdown-button")
            .addClass("close")
            .on('click', function (e) {
                e.stopPropagation()
                if (!self.dropKickObject.isOpen) {
                    self.dropKickObject.open();
                } else {
                    self.dropKickObject.close();
                }
            })
            .appendTo(this.$dropdownButtonWrapper);
    };

    Dropdown.prototype.handleScroll = function () {
        this.dropKickObject.funcs.close.apply(this.dropKickObject);
    };

    Dropdown.prototype.valueChanged = function() {
        var val = this.$dropDown.val();
        this.value = val === '' ? null : val;

        Style.renderStyles(this, null, this.$dkSelected);
        this.addButton();
        this.ensureRightPadding();

        this.togglePlaceholder(!this.value);
    };

    Dropdown.prototype.createEmptyItem = function() {
        return $('<option />', {
                value: '',
            }) // NOTE: Empty icon should still be visible even if iconColumn is not set
            .html(`<div class = "row-wrapper">
                    <div class = "icon-permanent"></div>
                    <div class = "icon-empty"></div>
                    <div class = "text">` + (this.data.emptyItemText || '...')  + `</div>
                </div>`)
            .css({display: 'none'});
    };

    Dropdown.prototype.renderMockData = function () {
        if (this.data.showEmptyItem)
            this.$dropDown.append(this.createEmptyItem());
        else // Must have option inside the select
            this.$dropDown.append($('<option>'));

        if (!this.data.mockData) return;
        this.$dropDown.append(_.map(this.data.mockData.split('\n'), function(item) {
            return $('<option />', {
                value: item,
                text: item
            });
        }));
    };

    // Builds the <option> for one datasource result. The icon url and the display text come from the record, so they
    // are set as a CSS value (.css) and a text node (.text) rather than concatenated into HTML: otherwise record data
    // could inject markup that DropKick re-renders as live DOM (stored XSS). The surrounding markup is a fixed template.
    Dropdown.prototype.buildOption = function (result) {
        var val = result[this.data.selectedKeyColumn || 'Id'];
        var img = null;
        var url = '';

        if (!!this.data.iconColumn) {
            img = result[this.data.iconColumn];
            var imageUrl = img && img.Url ? dynamicContentImage.getPath({
                imageName: img.Url,
                useThumbnail: true,
                resizeOption: 'fillKeepRatio',
                thumbnailFileType: 'png'
            }) : img;
            url = imageUrl ? 'url(' + imageUrl + ')' : '';
        }
        this.valueIsNumber = (typeof val === 'number');

        var $icon = $('<div />', { 'class': 'icon' });
        if (img)
            $icon.css('background-image', url);
        else
            $icon.css('display', 'none');

        var $row = $('<div />', { 'class': 'row-wrapper' })
            .append($('<div />', { 'class': 'icon-permanent' }))
            .append($icon)
            .append($('<div />', { 'class': 'text' }).text(this.getDisplayStringFromResult(result)));

        return $('<option />', { value: val }).append($row);
    };

    Dropdown.prototype._update = function (data) {
        this.loaded = true;

        this.$dropDown
            .find('option')
            .remove()
            .end();

        if (this.data.showEmptyItem)
            this.$dropDown.append(this.createEmptyItem());

        var self = this;
        $.each(data.results, function (key, result) {
            self.buildOption(result).appendTo(self.$dropDown);
        });

        this.dropKickObject.refresh();

        this.$dkSelected = this.$element.find('.dk-selected');

        if (this.data.hideEmptyItemInList && this.data.showEmptyItem)
            $(this.dropKickObject.data.optList).addClass('empty-item-hidden');

        Style.renderStyles(this, null, this.$dkSelected);
        this.addButton();
        this.ensureRightPadding();

        if (this.value) {
            this.setValue({ value: this.value });
        } else if (this.data.showEmptyItem) {
            this.togglePlaceholder(true);
            this.selectFirstItem();
        } else {
            this.selectFirstItem();
        }
    };

    Dropdown.prototype.getDisplayStringFromResult = function (result) {
        var column = this.getNameOfDisplayedColumn(result);
        return result[column];
    };

    Dropdown.prototype.getNameOfDisplayedColumn = function (result) {
        var keys = Object.keys(result);
        if (keys.length === 1) {
            return keys[0];
        }
        if (keys.indexOf(this.data.selectedColumnToShow) !== -1) {
            return this.data.selectedColumnToShow;
        }
        if (keys[0].toUpperCase() !== "ID") {
            return keys[0];
        }
        return keys[1];
    };

    Dropdown.prototype.focus = function () {
        this.$dropDown.trigger('focus');
    };

    Dropdown.prototype.getValue = function () {
        if (this.valueIsNumber && this.value !== null)
            return parseInt(this.value);
        return this.value === undefined
            ? null
            : this.value;
    };

    Dropdown.prototype.clearValue = function () {
        if (this.data.showEmptyItem) {
            this.value = null;
        }
        this.selectFirstItem();
        this.updateRequiredIndicator();
    };

    Dropdown.prototype.selectFirstItem = function () {
        this.dropKickObject.select(0, true);
        this.valueChanged();
    };

    Dropdown.prototype.setValue = function (update) {
        if (!this.loaded) {
            this.value = update.value;
        } else {
            if (update.value !== null && update.value !== undefined) {
                var option = _.find(this.$dropDown.children(), function(option) {
                    return option.value === update.value.toString();
                });

                if (option) {
                    this.value = update.value;
                    this.dropKickObject.select(update.value.toString(), true);
                    this.updateRequiredIndicator();
                    this.valueChanged();
                } else {
                    this.triggerEventIfEnabled('valueNotFound', update.value);
                    if(!this.isEventEnabled('valueNotFound')) {
                        alert('A value was mapped onto a drop down list, but the corresponding item was not found in the list. Saving this form will cause you to lose this information.');
                    }

                    this.clearValue();
                }
            } else {
                this.clearValue();
            }
        }
        this.updateRequiredIndicator();
    };

    Dropdown.prototype.ensureRightPadding = function () {
        this.$dkSelected.css('padding-right', 'max(23px, ' + this.$dkSelected.css('padding-right') + ')');
    }

    Dropdown.prototype.togglePlaceholder = function (isVisible) {
        if (!!isVisible) {
            this.$dkSelected.addClass('dropdown-stylable-placeholder');
            this.$dkSelected.addClass('empty');
        } else {
            this.$dkSelected.removeClass('dropdown-stylable-placeholder');
            this.$dkSelected.removeClass('empty');
        }
    };

    // Dropkick keeps every instance in a global cache (and loops over it on every click) until it's disposed
    Dropdown.prototype.unsubscribeEventHandlers = function () {
        var dropKickObject = this.dropKickObject;
        if (!dropKickObject || !dropKickObject.data) return;

        if (dropKickObject.data.elem && dropKickObject.data.elem.parentNode)
            dropKickObject.dispose();
        else
            delete window.Dropkick.cache[dropKickObject.data.cacheID];

        this.dropKickObject = null;
    };

    return Dropdown;
});
